// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exchange-ex__backdrop {
  z-index: 11000 !important;
}

.exchange-ex__sheet.player-session-results__sheet {
  max-width: 720px;
  --exch-bg: var(--bg-color, #f5f8fa);
  --exch-surface: var(--surface-color, #ffffff);
  --exch-text: var(--text-color, #1a2b3c);
  --exch-muted: var(--text-secondary, #78909c);
  --exch-border: var(--border-color, #e2e8f0);
  color: var(--exch-text);
  color-scheme: light dark;
}

.dark-mode .exchange-ex__sheet,
.exchange-ex__sheet.dark-mode,
html[data-theme="dark"] .exchange-ex__sheet {
  --exch-bg: var(--bg-color, #0f172a);
  --exch-surface: var(--surface-color, #111827);
  --exch-text: var(--text-color, #f9fafb);
  --exch-muted: var(--text-secondary, #9ca3af);
  --exch-border: rgba(255, 255, 255, 0.12);
}

.exchange-ex__toolbar {
  flex-shrink: 0;
  padding: 0 16px 10px;
  border-bottom: 1px solid var(--exch-border);
  background: var(--exch-surface);
}

.exchange-ex__search {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 12px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--exch-text) 4%, var(--exch-surface));
  border: 1px solid var(--exch-border);
}

.exchange-ex__search:focus-within {
  border-color: var(--brand-primary, #0877bc);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
}

.exchange-ex__search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  font: inherit;
  font-size: 14px;
  color: var(--exch-text);
  outline: none;
}

.exchange-ex__search input::placeholder {
  color: var(--exch-muted);
}

.exchange-ex__hint {
  margin: 8px 2px 0;
  font-size: 12px;
  font-weight: 600;
  color: var(--exch-muted);
}

.exchange-ex__body.player-session-results__body {
  padding: 12px 12px 24px !important;
  background: var(--exch-bg) !important;
  color: var(--exch-text);
}

.exchange-ex__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

.exchange-ex__card-wrap {
  position: relative;
}

.exchange-ex__card-wrap--current {
  outline: 2px solid color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);
  border-radius: 16px;
}

.exchange-ex__card-wrap--selected {
  outline: 2px solid var(--brand-primary, #0877bc);
  border-radius: 16px;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
}

.exchange-ex__current-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  padding: 3px 8px;
  border-radius: 8px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.exchange-ex__status {
  margin: 32px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: var(--exch-muted);
}

.exchange-ex__status--error {
  color: #c62828;
}

.dark-mode .exchange-ex__status--error,
html[data-theme="dark"] .exchange-ex__status--error {
  color: #ef9a9a;
}

.exchange-ex__busy {
  position: sticky;
  bottom: 0;
  margin: 12px 0 0;
  padding: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
  background: color-mix(in srgb, var(--exch-surface) 88%, transparent);
  backdrop-filter: blur(6px);
}

@media (min-width: 700px) {
  .exchange-ex__grid {
    grid-template-columns: 1fr 1fr;
  }

  .exchange-ex__toolbar {
    padding: 0 20px 12px;
  }

  .exchange-ex__body.player-session-results__body {
    padding: 16px 20px 28px !important;
  }
}

@media (max-width: 599px) {
  .exchange-ex__sheet.player-session-results__sheet {
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/ExchangeExerciseDialog.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;EACvC,4CAA4C;EAC5C,2CAA2C;EAC3C,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;;EAGE,mCAAmC;EACnC,6CAA6C;EAC7C,uCAAuC;EACvC,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,wEAAwE;EACxE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;EAC3C,wFAAwF;AAC1F;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qFAAqF;EACrF,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;EACnB,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".exchange-ex__backdrop {\n  z-index: 11000 !important;\n}\n\n.exchange-ex__sheet.player-session-results__sheet {\n  max-width: 720px;\n  --exch-bg: var(--bg-color, #f5f8fa);\n  --exch-surface: var(--surface-color, #ffffff);\n  --exch-text: var(--text-color, #1a2b3c);\n  --exch-muted: var(--text-secondary, #78909c);\n  --exch-border: var(--border-color, #e2e8f0);\n  color: var(--exch-text);\n  color-scheme: light dark;\n}\n\n.dark-mode .exchange-ex__sheet,\n.exchange-ex__sheet.dark-mode,\nhtml[data-theme=\"dark\"] .exchange-ex__sheet {\n  --exch-bg: var(--bg-color, #0f172a);\n  --exch-surface: var(--surface-color, #111827);\n  --exch-text: var(--text-color, #f9fafb);\n  --exch-muted: var(--text-secondary, #9ca3af);\n  --exch-border: rgba(255, 255, 255, 0.12);\n}\n\n.exchange-ex__toolbar {\n  flex-shrink: 0;\n  padding: 0 16px 10px;\n  border-bottom: 1px solid var(--exch-border);\n  background: var(--exch-surface);\n}\n\n.exchange-ex__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 12px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--exch-text) 4%, var(--exch-surface));\n  border: 1px solid var(--exch-border);\n}\n\n.exchange-ex__search:focus-within {\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n}\n\n.exchange-ex__search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  color: var(--exch-text);\n  outline: none;\n}\n\n.exchange-ex__search input::placeholder {\n  color: var(--exch-muted);\n}\n\n.exchange-ex__hint {\n  margin: 8px 2px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--exch-muted);\n}\n\n.exchange-ex__body.player-session-results__body {\n  padding: 12px 12px 24px !important;\n  background: var(--exch-bg) !important;\n  color: var(--exch-text);\n}\n\n.exchange-ex__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n}\n\n.exchange-ex__card-wrap {\n  position: relative;\n}\n\n.exchange-ex__card-wrap--current {\n  outline: 2px solid color-mix(in srgb, var(--brand-primary, #0877bc) 45%, transparent);\n  border-radius: 16px;\n}\n\n.exchange-ex__card-wrap--selected {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  border-radius: 16px;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n}\n\n.exchange-ex__current-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 2;\n  padding: 3px 8px;\n  border-radius: 8px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.exchange-ex__status {\n  margin: 32px 12px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--exch-muted);\n}\n\n.exchange-ex__status--error {\n  color: #c62828;\n}\n\n.dark-mode .exchange-ex__status--error,\nhtml[data-theme=\"dark\"] .exchange-ex__status--error {\n  color: #ef9a9a;\n}\n\n.exchange-ex__busy {\n  position: sticky;\n  bottom: 0;\n  margin: 12px 0 0;\n  padding: 12px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n  background: color-mix(in srgb, var(--exch-surface) 88%, transparent);\n  backdrop-filter: blur(6px);\n}\n\n@media (min-width: 700px) {\n  .exchange-ex__grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .exchange-ex__toolbar {\n    padding: 0 20px 12px;\n  }\n\n  .exchange-ex__body.player-session-results__body {\n    padding: 16px 20px 28px !important;\n  }\n}\n\n@media (max-width: 599px) {\n  .exchange-ex__sheet.player-session-results__sheet {\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
